import React from "react";
import { Button, Row, Col, Card, Typography, Space } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

const { Text } = Typography;

export function Container({ icono, titulo, children, botonExtra, onClickRetornar, sinCard }) {
	return (
		<Row>
			<Col span={24}>
				<Card
					title={
						<React.Fragment>
							{onClickRetornar && (
								<Button
									type="link"
									onClick={onClickRetornar}
									style={{ padding: "0", margin: 0, paddingRight: "10px" }}
								>
									<ArrowLeftOutlined style={{ color: "#333333", fontSize: "20px" }} />
								</Button>
							)}
							<Text>
								<Space>
									{icono}
									{titulo}
								</Space>
							</Text>
						</React.Fragment>
					}
					headStyle={{ fontWeight: "400", ...(sinCard ? { borderBottom: 0, padding: 0 } : {}) }}
					bordered={!sinCard}
					bodyStyle={sinCard ? { padding: 0 } : undefined}
					style={sinCard ? { background: "transparent" } : undefined}
					extra={botonExtra}
				>
					{children}
				</Card>
			</Col>
		</Row>
	);
}
